<fa-icon [icon]="faFileExport" (click)="onClick()" [matTooltip]="'download_as_csv' | translate" matTooltipPosition="above"></fa-icon>
